import { z } from 'zod';
import { colorSchema, easingSchema, normalizedRectSchema, vec3Schema } from './common';
export const cameraSchema = z.object({
    type: z.enum(['perspective', 'orthographic']).default('perspective'),
    position: vec3Schema.default({ x: 0, y: 0, z: 5 }),
    rotation: vec3Schema.default({ x: 0, y: 0, z: 0 }),
    target: vec3Schema.default({ x: 0, y: 0, z: 0 }),
    fov: z.number().min(1).max(179).default(45),
    focalLength: z.number().positive().optional(),
    focusDistance: z.number().positive().optional(),
    aperture: z.number().positive().optional(),
    near: z.number().positive().default(0.1),
    far: z.number().positive().default(1000),
    movement: z
        .enum([
        'slow_push',
        'slow_pull',
        'dolly',
        'truck',
        'orbit',
        'crane',
        'tilt',
        'pan',
        'rack_focus',
        'reveal',
        'handheld',
        'static',
    ])
        .default('static'),
});
export const motionSchema = z.object({
    start: vec3Schema.optional(),
    end: vec3Schema.optional(),
    easing: easingSchema.optional(),
    intensity: z.number().min(0).max(1).default(0.5),
});
export const typographyStyleSchema = z.object({
    fontFamily: z.string().optional(),
    fontSize: z.number().min(0).optional(),
    fontWeight: z.union([z.number(), z.string()]).optional(),
    color: colorSchema.optional(),
    textAlign: z.enum(['left', 'center', 'right']).default('center'),
    lineHeight: z.number().positive().optional(),
    letterSpacing: z.number().optional(),
    textTransform: z.enum(['none', 'uppercase', 'lowercase', 'capitalize']).default('none'),
});
export const typographySchema = z.object({
    text: z.string(),
    style: z.enum([
        'title',
        'subtitle',
        'chapter',
        'quote',
        'statistic',
        'lower-third',
        'caption',
        'credit',
    ]),
    position: normalizedRectSchema.optional(),
    animation: z
        .enum([
        'fade',
        'slide',
        'mask-reveal',
        'word-reveal',
        'character-reveal',
        'tracking',
        'scale',
        'blur',
        'clip',
    ])
        .optional(),
    animationDuration: z.number().positive().optional(),
    delay: z.number().min(0).default(0),
    customStyle: typographyStyleSchema.optional(),
});
export const lightingSchema = z.object({
    key: z
        .object({
        intensity: z.number().min(0).max(10).default(1),
        color: colorSchema.optional(),
        position: vec3Schema.optional(),
    })
        .default({ intensity: 1 }),
    fill: z
        .object({
        intensity: z.number().min(0).max(10).default(0.5),
        color: colorSchema.optional(),
    })
        .default({ intensity: 0.5 }),
    rim: z
        .object({
        intensity: z.number().min(0).max(10).default(0.3),
        color: colorSchema.optional(),
    })
        .default({ intensity: 0.3 }),
    ambient: z
        .object({
        intensity: z.number().min(0).max(10).default(0.2),
        color: colorSchema.optional(),
    })
        .default({ intensity: 0.2 }),
});
export const effectSchema = z.object({
    type: z.enum([
        'bloom',
        'dof',
        'grain',
        'vignette',
        'chromatic-aberration',
        'halation',
        'color-grade',
        'sharpen',
        'blur',
    ]),
    intensity: z.number().min(0).max(1).default(0.5),
    params: z.record(z.unknown()).optional(),
});
export const transitionSchema = z.object({
    type: z.enum(['cut', 'fade', 'dissolve', 'wipe', 'push', 'slide', 'zoom', 'iris', 'none']),
    duration: z.number().min(0).default(0),
    easing: easingSchema.optional(),
});
export const cameraSchemaExport = cameraSchema;
export const motionSchemaExport = motionSchema;
export const typographySchemaExport = typographySchema;
export const lightingSchemaExport = lightingSchema;
export const effectSchemaExport = effectSchema;
export const transitionSchemaExport = transitionSchema;
//# sourceMappingURL=cinematic.js.map